import React from 'react';
import { Link } from 'react-router-dom';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import './styles/Home.css';
  
const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    height: '200px',
    backgroundPosition: 'center',
}

const slideImages = [
    {
        alt: 'image 1',
        caption: 'image 1',
        url: '/assets/pictures/slideshowImages/01.jpg',
    },
    {
        alt: 'image 3',
        caption: 'image 3',
        url: '/assets/pictures/slideshowImages/03.jpg',
    },
    {
        alt: 'image 4',
        caption: 'image 3',
         url: '/assets/pictures/slideshowImages/04.jpg',
    },
    {
        alt: 'image 5',
        caption: 'image 3',
         url: '/assets/pictures/slideshowImages/05.jpg',
    },
    {
        alt: 'image 6',
        caption: 'image 3',
         url: '/assets/pictures/slideshowImages/06.jpg',
    },


]

function Home() {
    return(
        <div className='container'>
            <div className='homeContentContainer'>
                <div className='slideContainer'>
                    <Slide arrows={false}>
                        {slideImages.map((slideImage, index)=> (
                            <div key={index}>
                            <div className="homeSlideDiv" style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})` }}>
                                {/* <span style={spanStyle}>{slideImage.caption}</span> */}
                            </div>
                            </div>
                        ))} 
                    </Slide>                
                </div>

                <div className='textContainer'>
                    <h1>Aktuelles</h1>
                    <h2>Herzlich Willkommen auf der Zeltlager-Seite der Schreberjugend Südwest!</h2>
                    <p style={{fontWeight: 'bold'}}>Die Anmeldung für das Zeltlager 2026 ist geöffnet! Hier gehts direkt zum {<Link to={'/Anmeldung'}>Anmeldeformular</Link>}.</p>
                    <p>Hier findet ihr aktuelle Informationen rund um unser Zeltlager, könnt in den Bildern der vergangenen Jahre stöbern oder schon mal die Packliste herunterladen…</p>
                    <p><strong>Per Mail an <a href='mailto:zeltlager@schreberjugend-suedwest.de'>zeltlager@schreberjugend-suedwest.de</a> können Sie mit uns in Kontakt treten.</strong></p>
                </div>

            </div>
            <div className='bottomContainer'>
                <Link to='https://deutsche-schreberjugend.de/'>
                    <p> Deutsche Schreberjugend</p>
                </Link>
                <Link to={'/impressum'}>
                    <p>Impressum</p>
                </Link>
                <Link to={'/datenschutz'}>
                    <p>Datensschutz</p>
                </Link>
            </div>
        </div>
    );
}

export default Home;